// extracted by mini-css-extract-plugin
export default {"main":"two-columns_main__N-SjF","main_place_profile":"two-columns_main_place_profile__N9OSl"};